import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { ReactNode } from "react";
import { Deposito } from "@/shared/types/deposito";

export interface DepositoEditRequest {
    nombre: string,
}

export async function editDeposito(id: string, request: DepositoEditRequest): Promise<Deposito> {
    await sleep(1000);
    const response = await api.put("depositos/" + id, request);
    return response.data;
}

export function useEditDepositoMutation(id: string, mutationConfig: MutationConfig<Deposito, DepositoEditRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async (request: DepositoEditRequest) => await editDeposito(id, request),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["depositos"] });
        },
    })
}

export interface EditDepositoMutationProps {
    id: string,
    mutationConfig?: MutationConfig<Deposito, DepositoEditRequest>,
    children?: (mutationResult: MutationResult<Deposito, DepositoEditRequest>) => ReactNode
}

export function EditDepositoMutation({
    id,
    children,
    mutationConfig
}: EditDepositoMutationProps) {
    const mutationResult = useEditDepositoMutation(id, mutationConfig);
    return children && children(mutationResult)
}
